import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { formatMoney } from "../config/siteConfig";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = Number(product.price);
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <Link onClick={toTop} to="/shop" className="cart-page__continue">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__header">
        <h1 className="cart-page__title">Your cart</h1>
        <Link onClick={toTop} to="/shop" className="cart-page__continue">
          Continue shopping
        </Link>
      </div>

      <div className="cart-page__table-header">
        <span className="cart-page__col-product">PRODUCT</span>
        <span className="cart-page__col-quantity">QUANTITY</span>
        <span className="cart-page__col-total">TOTAL</span>
      </div>

      <div className="cart-page__items">
        {cartItems.map((item, index) => {
          const product = getProductById(item.id);
          if (!product) return null;
          const price = Number(product.price);
          const itemTotal = price * item.quantity;

          return (
            <div key={`${item.id}-${index}`} className="cart-page__item">
              <div className="cart-page__item-product">
                <img
                  src={product.images ? product.images[0] : product.image}
                  alt={product.name}
                  className="cart-page__item-image"
                />
                <div className="cart-page__item-details">
                  <h3 className="cart-page__item-name">{product.name}</h3>
                  <p className="cart-page__item-price">{formatMoney(product.price)}</p>
                  {item.color && (
                    <p className="cart-page__item-option">
                      Colour: {item.color}
                    </p>
                  )}
                  {item.size && item.size !== "One size" && (
                    <p className="cart-page__item-option">Size: {item.size}</p>
                  )}
                </div>
              </div>

              <div className="cart-page__item-quantity">
                <div className="cart-page__qty-box">
                  <button
                    className="cart-page__qty-btn"
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity - 1
                      )
                    }
                  >
                    -
                  </button>
                  <span className="cart-page__qty-value">{item.quantity}</span>
                  <button
                    className="cart-page__qty-btn"
                    onClick={() =>
                      handleUpdateQuantity(
                        item.id,
                        item.size,
                        item.color,
                        item.quantity + 1
                      )
                    }
                  >
                    +
                  </button>
                </div>
                <button
                  className="cart-page__remove-btn"
                  onClick={() => removeFromCart(item.id, item.size, item.color)}
                >
                  <svg
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                  >
                    <path
                      d="M1.75 3.5H2.91667H12.25"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.66667 3.5V2.33333C4.66667 2.02391 4.78958 1.72717 5.00838 1.50838C5.22717 1.28958 5.52391 1.16667 5.83333 1.16667H8.16667C8.47609 1.16667 8.77283 1.28958 8.99162 1.50838C9.21042 1.72717 9.33333 2.02391 9.33333 2.33333V3.5M11.0833 3.5V11.6667C11.0833 11.9761 10.9604 12.2728 10.7416 12.4916C10.5228 12.7104 10.2261 12.8333 9.91667 12.8333H4.08333C3.77391 12.8333 3.47717 12.7104 3.25838 12.4916C3.03958 12.2728 2.91667 11.9761 2.91667 11.6667V3.5H11.0833Z"
                      stroke="currentColor"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div className="cart-page__item-total">
                {formatMoney(itemTotal)}
              </div>
            </div>
          );
        })}
      </div>

      <div className="cart-page__footer">
        <div className="cart-page__summary">
          <div className="cart-page__subtotal">
            <span>Estimated total</span>
            <span className="cart-page__subtotal-value">
              {formatMoney(subtotal)}
            </span>
          </div>

          <button className="cart-page__checkout-btn" onClick={handleCheckout}>
            Check out
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
